module.exports = function getResource(label) {
    const resources = {
        // Ratings & Reviews guidelines
        legalMessage: 'Product reviews are managed by a third party to verify authenticity and compliance with our'
    };
    return resources[label];
};
